const initialState = {
	list: [],
	datetime: null,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'NEWS_LIST_SET') {
		let newState = Object.assign({}, state);
    newState.list = action.payload.list;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'NEWS_ITEM_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.news_id === action.payload.id);
		if (index >= 0) {
			if (action.payload.type === 'read') {
				newState.list[index].news_unread = 0;
			}
		}
		return newState;
	}
	else {
		return state;
	}
}
